import React, { useEffect, useState } from "react";
import { IntroTitle } from "../../components/IntroTitle/IntroTitle";
import { Card } from "../../components/Card/Card";
import { Footer } from "../../components/Footer/Footer";
import { Header } from "../../components/Header/Header";
import { MultiRange } from "../../components/MultiRange/MultiRange";
import { InfoTrasparenti } from "../../components/InfoTrasparenti/InfoTrasparenti";
import { useApi } from "../../hooks/useApi";
import { formatCurrencyLabel } from "../../helpers/Pipes";
import { Simulation } from "../../hooks/simulationData";
import { useDynatrace } from "../../hooks/useDynatrace";
import { chipsGroupDefault } from "../../helpers/utils";

export const Page = ({
  linkUrl,
  sommaMinValue,
  sommaMaxValue,
  sommaDefaultValue,
  sommaMinValueLabel,
  sommaMaxValueLabel,
  sommaStep,
  rataDefaultValue,
  rataMinValueLabel,
  rataMinValue,
  rataMaxValue,
  rataMaxValueLabel,
  rataStep,
  onNextRoute,
}) => {
  const { getProntuario } = useApi();

  const [importoValue, setImportoValue] = useState(sommaDefaultValue);
  const [rataValue, setRataValue] = useState(rataDefaultValue);
  const [_rataMinValueLabel, setRataMinValueLabel] = useState(rataMinValueLabel);
  const [_rataMaxValueLabel, setRataMaxValueLabel] = useState(rataMaxValueLabel);
  const [rataStepValue, setRataStepValue] = useState(rataStep);

  const {} = useDynatrace();
  
  useEffect(() => {
    window.hasRoot = true;

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    
    getProntuario().then((res) => {
      Simulation.allTables = res;

      if (Object.keys(params).length > 0) {
        if (params.importo) {
          Simulation.set("importo", params.importo);
        }
        if (params.obiettivo) {
          const purposeId = params.obiettivo; // SME
          const selectedPurpose = chipsGroupDefault.filter((_) => _.id == purposeId)[0];
          const options = chipsGroupDefault.map((itm, idx) => {
            return {
                label: itm.title,
                value: itm.id,
                image: itm.iconName,
            };
          });

          Simulation.set("purposeSelectValue", options.filter((_) => _.value == purposeId)[0]);
          Simulation.set("purpose", selectedPurpose.id);
          Simulation.set("purposeIconName", selectedPurpose.iconName);
          Simulation.set("purposeCode", selectedPurpose.cod);
          Simulation.set("purposeTitle", selectedPurpose.title);
        }
      }  
      
      onImportoChange(Simulation.get("importo"));
      

      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute("6LeR4s8UAAAAAD6c_HG0bGl45h6TOaUwL_Y5MjB3", {
            action: "simulatore",
          })
          .then((token) => {
            Simulation.set("tokenRecaptcha", token);
          });
      });
    });
  }, []);

  const onImportoChange = (importo) => {
    setImportoValue(importo);
    Simulation.set("importo", importo);
    Simulation.update(importo, rataValue);
    setRataMinValueLabel(Simulation.get("rataRangeMin"));
    setRataMaxValueLabel(Simulation.get("rataRangeMax"));
    setRataStepValue(Simulation.get("rataStep"));
  };
  const onRataChange = (rata) => {
    setRataValue(rata);
    Simulation.set("rata", rata);
    Simulation.update(importoValue, rata);
  };

  return (
    <div className="container-page simulatore_page-01">
      <Header customClasses="" />

      <main>
        <div className="container --range">
          <IntroTitle titleSelect="first" customClasses="mBottom6x item" />

          <MultiRange
            customClasses="mBottom6x item"
            sommaMinValue={sommaMinValue}
            sommaMaxValue={sommaMaxValue}
            sommaStep={sommaStep}
            sommaMinValueLabel={sommaMinValueLabel}
            sommaMaxValueLabel={sommaMaxValueLabel}
            rataMinValue={rataMinValue}
            rataMaxValue={rataMaxValue}
            //
            rataDefaultValue={rataValue}
            sommaDefaultValue={importoValue}
            rataStep={rataStepValue}
            rataDefaultValueLabel={Simulation.getRataConverted(rataValue)}
            rataMinValueLabel={_rataMinValueLabel}
            rataMaxValueLabel={formatCurrencyLabel(_rataMaxValueLabel)}
            onSubmit={() => onNextRoute()}
            onImportoChange={(event) => onImportoChange(event)}
            onRataChange={(event) => onRataChange(event)}
          />

          <Card
            type="card-link"
            hasLink="yes"
            iconName="otp-code"
            description="Hai già richiesto un preventivo e hai ricevuto il codice di tracciamento?"
            linkText="Recupera il tuo preventivo"
            linkUrl={linkUrl}
            linkTarget="_blank"
            customClasses="mBottom6x item"
          />

          <span></span>
        </div>
      </main>

      <InfoTrasparenti />

      <Footer />
    </div>
  );
};
